import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React, { Component } from 'react';
import { UserDeviceContext } from '../../context';
import { getBrowser, isMobile } from '../get-browser';
import { jsx as _jsx } from "react/jsx-runtime";
export class TouchEventDetection extends Component {
  constructor(props) {
    super(props);
    // Handle desktop browsers that are using touch events
    _defineProperty(this, "pageTouched", () => {
      this.setState({
        isTouch: true
      });
    });
    this.state = {
      isTouch: false
    };
  }
  componentDidMount() {
    /**
     * Default `isTouch` to true for known touch devices.
     * This must be done after mounting the component to avoid conflicts with
     * server-side rendering when hydrating.
     *
     * This would normally trigger a new render loop for all of the context
     * consumers, but in practice it gets batched together with re-renders
     * already caused by Apollo queries.
     */
    if (isMobile(getBrowser())) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        isTouch: true
      });
    }
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      "data-name": "touch-detection",
      className: this.props.className,
      onTouchStart: this.state.isTouch ? null : this.pageTouched,
      "data-id": "with-touch-detection_touch-event-detection_div",
      children: /*#__PURE__*/_jsx(UserDeviceContext.Provider, {
        value: {
          isUsingTouch: this.state.isTouch
        },
        children: this.props.children
      })
    });
  }
}